class UpdateNakiNigunAlbumStatusOptions {
    albumId = null;
    title = null;
    isPremium = false;
    isUnavailableInApp = false;

    constructor(albumId, title, isPremium, isUnavailableInApp) {
        this.albumId = albumId;
        this.title = title;
        this.isPremium = isPremium;
        this.isUnavailableInApp = isUnavailableInApp;
    }
}

export default UpdateNakiNigunAlbumStatusOptions;
